import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, Inject } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatToolbarModule } from '@angular/material/toolbar';

export interface BackToOrdersListDialogData {
  lockedByUser: string;
}
@Component({
  selector: 'ciwc-back-to-orders-list-dialog',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [CommonModule, MatDialogModule, MatButtonModule, MatToolbarModule],
  templateUrl: './back-to-orders-list-dialog.component.html',
  styleUrl: './back-to-orders-list-dialog.component.scss',
})
export class BackToOrdersListDialogComponent {
  constructor(
    public dialogRef: MatDialogRef<BackToOrdersListDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: BackToOrdersListDialogData,
  ) {}

  onConfirm(): void {
    this.dialogRef.close(true);
  }
}
